<template>
  <span
    :title="country"
    :class="flagCss(country)">
  </span>
</template>

<script>
  import isoc from 'isoc';

  export default {
    props: {
      country: {
        type: String,
        required: true
      },
      squared: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      flagCss(country) {
        const i = isoc.filter( c => c.name.short === country )[0];

        if(i) {
          const classes = ["flag-icon"];
          const code = i.alpha2.toLowerCase();

          classes.push(`flag-icon-${code}`);

          if(this.squared) {
            classes.push("flag-icon-squared");
          }

          return classes.join(" ");
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// IsrsFlag.vue?3c0a4258